import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';

const TermsOfUsePage = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      
      <div className="pt-32 pb-20 px-6 lg:px-12 bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <div className="glass-card p-8 md:p-12">
            <h1 className="heading-font text-4xl text-[#1E293B] mb-6" data-testid="terms-of-use-title">
              TERMS OF USE
            </h1>
            <p className="text-[#64748B] text-sm mb-8">
              Last Updated: January 2024
            </p>

            <div className="space-y-8 text-[#475569]">
              <section>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-4">1. Acceptance of Terms</h2>
                <p className="mb-4">
                  Welcome to Simpson & Munro (India) Pvt Ltd ("Company", "we", "our", or "us"). These Terms of Use 
                  govern your access to and use of our website, products, and services.
                </p>
                <p>
                  By accessing or using our website, you agree to be bound by these Terms of Use. If you do not agree 
                  with any part of these terms, you should not use our website or services.
                </p>
              </section>

              <section>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-4">2. Use of Website</h2>
                
                <h3 className="font-semibold text-[#1E293B] mb-2">2.1 License to Use</h3>
                <p className="mb-4">
                  We grant you a limited, non-exclusive, non-transferable license to access and use our website for 
                  business purposes in accordance with these Terms.
                </p>

                <h3 className="font-semibold text-[#1E293B] mb-2">2.2 Prohibited Uses</h3>
                <p className="mb-2">You agree not to:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Use the website for any illegal or unauthorized purpose</li>
                  <li>Interfere with or disrupt the website or servers</li>
                  <li>Attempt to gain unauthorized access to any systems</li>
                  <li>Copy, reproduce, or distribute content without permission</li>
                  <li>Use automated systems to access the website (bots, scrapers)</li>
                  <li>Transmit viruses, malware, or harmful code</li>
                  <li>Impersonate any person or entity</li>
                </ul>
              </section>

              <section>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-4">3. Products and Services</h2>
                
                <h3 className="font-semibold text-[#1E293B] mb-2">3.1 Product Information</h3>
                <p className="mb-4">
                  We strive to provide accurate product information. However, we do not warrant that product descriptions, 
                  specifications, or other content is accurate, complete, reliable, current, or error-free.
                </p>

                <h3 className="font-semibold text-[#1E293B] mb-2">3.2 Quotations</h3>
                <p className="mb-4">
                  Quotations provided through our website or configurator are estimates only. Final pricing may vary 
                  based on specifications, customization, market conditions, and other factors. Quotations are valid 
                  for the period specified and are subject to acceptance.
                </p>

                <h3 className="font-semibold text-[#1E293B] mb-2">3.3 Orders and Acceptance</h3>
                <p className="mb-2">
                  Submission of a Request for Quotation (RFQ) does not constitute a binding order. A binding contract 
                  is formed only when:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>You submit a formal purchase order</li>
                  <li>We accept your order in writing</li>
                  <li>Payment terms are agreed upon</li>
                </ul>
              </section>

              <section>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-4">4. Pricing and Payment</h2>
                
                <h3 className="font-semibold text-[#1E293B] mb-2">4.1 Prices</h3>
                <ul className="list-disc pl-6 space-y-2 mb-4">
                  <li>All prices are in Indian Rupees (INR)</li>
                  <li>Prices are exclusive of GST unless otherwise stated</li>
                  <li>We reserve the right to change prices without notice</li>
                  <li>Freight and handling charges are additional</li>
                </ul>

                <h3 className="font-semibold text-[#1E293B] mb-2">4.2 Payment Terms</h3>
                <p>
                  Payment terms are specified in quotations and invoices. Standard terms are 50% advance payment 
                  and 50% before dispatch, unless otherwise agreed in writing.
                </p>
              </section>

              <section>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-4">5. Delivery and Shipping</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Delivery timelines are estimates and not guaranteed</li>
                  <li>Risk of loss passes to buyer upon dispatch</li>
                  <li>Delays due to force majeure are not our responsibility</li>
                  <li>Buyer must inspect goods upon delivery and report defects within 7 days</li>
                </ul>
              </section>

              <section>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-4">6. Warranty and Returns</h2>
                
                <h3 className="font-semibold text-[#1E293B] mb-2">6.1 Product Warranty</h3>
                <p className="mb-4">
                  Our products are covered by a standard warranty of 12 months from date of installation or 18 months 
                  from date of dispatch, whichever occurs first. The warranty covers manufacturing defects only.
                </p>

                <h3 className="font-semibold text-[#1E293B] mb-2">6.2 Warranty Exclusions</h3>
                <p className="mb-2">The warranty does not cover:</p>
                <ul className="list-disc pl-6 space-y-2 mb-4">
                  <li>Normal wear and tear</li>
                  <li>Improper installation or use</li>
                  <li>Damage from unauthorized modifications</li>
                  <li>Damage from external causes (accidents, misuse)</li>
                  <li>Failure to follow installation and maintenance guidelines</li>
                </ul>

                <h3 className="font-semibold text-[#1E293B] mb-2">6.3 Returns</h3>
                <p>
                  Custom-manufactured products cannot be returned unless defective. Standard products may be returned 
                  within 7 days if unused and in original packaging, subject to a restocking fee.
                </p>
              </section>

              <section>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-4">7. Intellectual Property</h2>
                <p className="mb-4">
                  All content on this website, including text, graphics, logos, images, and software, is the property 
                  of Simpson & Munro (India) Pvt Ltd or its licensors and is protected by Indian and international 
                  copyright and trademark laws.
                </p>
                <p>
                  You may not use our trademarks, logos, or brand elements without our prior written consent.
                </p>
              </section>

              <section>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-4">8. Limitation of Liability</h2>
                
                <h3 className="font-semibold text-[#1E293B] mb-2">8.1 Disclaimer</h3>
                <p className="mb-4">
                  TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE PROVIDE OUR WEBSITE AND SERVICES "AS IS" WITHOUT WARRANTIES 
                  OF ANY KIND, EXPRESS OR IMPLIED.
                </p>

                <h3 className="font-semibold text-[#1E293B] mb-2">8.2 Limitation</h3>
                <p className="mb-2">
                  Our total liability for any claims arising from products or services shall not exceed the amount 
                  paid for the specific product or service. We shall not be liable for:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Indirect, incidental, or consequential damages</li>
                  <li>Loss of profits, data, or business opportunities</li>
                  <li>Damages arising from third-party products or services</li>
                  <li>Delays or failures due to force majeure events</li>
                </ul>
              </section>

              <section>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-4">9. Indemnification</h2>
                <p>
                  You agree to indemnify and hold harmless Simpson & Munro (India) Pvt Ltd, its officers, directors, 
                  employees, and agents from any claims, damages, losses, or expenses arising from your use of our 
                  website or services, or your violation of these Terms.
                </p>
              </section>

              <section>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-4">10. User Content</h2>
                <p className="mb-4">
                  If you submit any content, data, or information through our website (RFQs, drawings, specifications), 
                  you grant us a non-exclusive license to use such information for the purpose of fulfilling your order 
                  and providing services.
                </p>
                <p>
                  You represent that you have all rights necessary to submit such content and that it does not violate 
                  any third-party rights.
                </p>
              </section>

              <section>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-4">11. Privacy</h2>
                <p>
                  Your use of our website is also governed by our Privacy Policy. Please review our Privacy Policy to 
                  understand how we collect, use, and protect your information.
                </p>
              </section>

              <section>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-4">12. Termination</h2>
                <p>
                  We reserve the right to terminate or suspend your access to our website at any time, without notice, 
                  for conduct that we believe violates these Terms or is harmful to our business or other users.
                </p>
              </section>

              <section>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-4">13. Governing Law and Jurisdiction</h2>
                <p className="mb-4">
                  These Terms shall be governed by and construed in accordance with the laws of India, without regard 
                  to conflict of law principles.
                </p>
                <p>
                  Any disputes arising from these Terms or your use of our website shall be subject to the exclusive 
                  jurisdiction of the courts in Kolkata, West Bengal, India.
                </p>
              </section>

              <section>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-4">14. Severability</h2>
                <p>
                  If any provision of these Terms is found to be invalid or unenforceable, the remaining provisions 
                  shall continue in full force and effect.
                </p>
              </section>

              <section>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-4">15. Modifications</h2>
                <p>
                  We reserve the right to modify these Terms at any time. Changes will be effective immediately upon 
                  posting to the website. Your continued use of the website after changes constitutes acceptance of 
                  the modified Terms.
                </p>
              </section>

              <section>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-4">16. Contact Information</h2>
                <p className="mb-3">
                  For questions about these Terms of Use, please contact us:
                </p>
                <div className="bg-gray-50 p-6 rounded-lg border border-gray-200">
                  <p className="font-semibold text-[#1E293B] mb-3">Simpson & Munro (India) Pvt Ltd</p>
                  <p>4 Lyons Range</p>
                  <p>Kolkata 700001</p>
                  <p>West Bengal, India</p>
                  <p className="mt-3">
                    <strong>Email:</strong> sales@simpsonmunro.in, simpsmunro@gmail.com<br/>
                    <strong>Phone:</strong> +91 33 2248 1686
                  </p>
                </div>
              </section>

              <section className="bg-blue-50 p-6 rounded-lg border border-blue-200">
                <p className="text-sm text-[#1E293B]">
                  <strong>Acknowledgment:</strong> By using our website and services, you acknowledge that you have 
                  read, understood, and agree to be bound by these Terms of Use.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsOfUsePage;
